export default __webpack_public_path__ + "static/media/Mindcurse Staff.ecfc5131.jpg";